export default __webpack_public_path__ + "static/media/02_Arevatsagi_dzor.1234c0b3.jpg";